import React from 'react';
import clsx from 'clsx';
import NumArrow from '@/pages/intelligence/pages/TopCharts/components/DetailsPage/NumArrow';
import IconTipsCom from '@sg/components/IconTipsCom';
import { getNumConfig } from '@sg/utils/common';
import { formatMainValue } from '@sg/pages/StudioManagement/LiveTitles/pages/LiveVisualizationAll/utils';
import {
  LiveMetricTrendChart,
  LIVE_METRIC_TREND_CHART_HEIGHT,
  shouldRenderTrendChart,
  type ILiveMetricTrendData,
} from '@sg/pages/StudioManagement/LiveTitles/utils/liveMetricTrendChart';
import './index.scss';

interface IFinanceMetricBoardProps {
  title: string;
  tipString?: string;
  num?: number | null;
  displayValue?: string;
  formatter?: string;
  unit?: string;
  momText?: string;
  trendData?: ILiveMetricTrendData;
  chartHeight?: number;
  className?: string;
}

const FinanceMetricBoard: React.FC<IFinanceMetricBoardProps> = ({
  title,
  tipString,
  num,
  displayValue,
  formatter,
  unit,
  momText,
  trendData,
  chartHeight = LIVE_METRIC_TREND_CHART_HEIGHT,
  className,
}) => {
  const numArrowData = getNumConfig(momText || '', 0);
  const showTrendChart = shouldRenderTrendChart(trendData);
  const mainValue = displayValue ?? formatMainValue(num, formatter, unit);

  return (
    <div className={clsx('dbs-ltf-metric-board', className)}>
      <div className="dbs-ltf-metric-board__title">
        <span>{title}</span>
        {tipString ? <IconTipsCom tipString={tipString} mWidth={360} /> : null}
      </div>

      <div className="dbs-ltf-metric-board__body">
        <div className="dbs-ltf-metric-board__value-row">
          <span className="dbs-ltf-metric-board__num">
            {mainValue}
          </span>
          <div className="dbs-ltf-metric-board__mom">
            <span className="dbs-ltf-metric-board__mom-label">MoM</span>
            {numArrowData ? (
              <NumArrow dataContent={numArrowData} type="num" />
            ) : (
              <span className="dbs-ltf-metric-board__mom-value">-</span>
            )}
          </div>
        </div>

        {showTrendChart && (
          <LiveMetricTrendChart
            title={title}
            trendData={trendData}
            formatter={formatter}
            unit={unit}
            height={chartHeight}
            className="dbs-ltf-metric-board__chart"
            tooltipClassName="dbs-ltf-chart-tooltip"
          />
        )}
      </div>
    </div>
  );
};

export default FinanceMetricBoard;
